import { render, staticRenderFns } from "./SfCarousel.vue?vue&type=template&id=b5f50fba&scoped=true&"
import script from "./SfCarousel.vue?vue&type=script&lang=js&"
export * from "./SfCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SfCarousel.vue?vue&type=style&index=0&id=b5f50fba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f50fba",
  null
  
)

export default component.exports